/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

/**
 * Wrap a list of callbacks,
 * - which may be added by calling .add(cb),
 * - and fired by calling .fire(your,args).
 *
 * - .fire() may be called once only,
 * - when .add() is called after .fire() was called,
 *   then the callback is called immediately with arguments
 *   that were used to the call .fire().
 *
 * Example:
 *   const focbl = new FireOnceCallbackList;
 *   focbl.add( function(a,b) { console.log({w:'first',a,b}); } );
 *   focbl.add( function(a,b) { console.log({w:'secnd',a,b}); } );
 *   focbl.fire('xyz',2);
 *   focbl.add( function(a,b) { console.log({w:'third',a,b}); } );
 *
 * Result:
 *   {w:"first",a:"xyz",b:2}
 *   {w:"secnd",a:"xyz",b:2}
 *   {w:"third",a:"xyz",b:2}
 *
 */
export class FireOnceCallbackList {

	constructor() {
		this._fired = false;
		this._fire_args = [];
		this._callback_list = [];
	}

	/**
	 * @param {...*} args
	 */
	fire( ...args ) {
		if( this._fired ) {
			throw new Error('FireOnceCallbackList was fired already');
		}
		this._fire_args = args;
		while( this._callback_list.length ) {
			const cb = this._callback_list.shift();
			if( cb ) cb.apply(this,this._fire_args);
		}
		this._fired = true;
	}

	/**
	 * @param {Closure} cb
	 */
	add( cb ) {
		if( this._fired ) {
			cb.apply(this,this._fire_args);
		} else {
			this._callback_list.push(cb);
		}
	}
}

